export const Videos = {
  landing: {
    intro: './videos/Hero_section_withot_text.mp4',
  },
  lightning: './videos/lightning.webm',
  coin: './videos/Coin_Post_1_1.webm',
  tokenSale: { intro: './videos/token_sale.mp4' },
};
